(ns rothko.theme.manatee.footer
  (:refer-clojure :exclude [rem])
  (:require [garden.units :refer [percent rem]]))

(def padding (rem 1))

(def main
  {:primary
   {:padding padding}

   :sticky
   {:bottom 0
    :position-main :sticky
    :position-fallback :fixed}

   :fixed
   {:bottom 0
    :position-main :fixed}

   :full-width
   {:width (percent 100)}})
